import { useEffect, useState } from 'react';
import { CompareOperator, compare } from 'compare-versions';

import { isInDesktopMode } from 'libs/gutClient/electronBridge';

export interface UseDesktopCompatibleProps {
  feature?: Features;
  compareOperator?: CompareOperator;
  desktopVersion?: string;
}

type Features = 'tab' | 'winHamburger';

const featureMap: { [key in Features]: string } = {
  tab: '0.2.0',
  winHamburger: '0.1.13',
};

const unreachableFeatureVersion = '0.0.999';
const unreachableDesktopVersion = '0.0.0';

export const useDesktopCompatibility = (props: UseDesktopCompatibleProps) => {
  const [isDesktopCompatible, setIsDesktopCompatible] = useState(true);
  const { feature, compareOperator = '>=', desktopVersion } = props;

  useEffect(() => {
    const checkCompatibility = async () => {
      const featureVersion = featureMap[feature] || unreachableFeatureVersion;

      if (isInDesktopMode()) {
        const desktopAppVersion =
          desktopVersion ||
          (await window?.appConfig?.getVersion?.()) ||
          unreachableDesktopVersion;

        setIsDesktopCompatible(
          featureVersion &&
            compare(desktopAppVersion, featureVersion, compareOperator),
        );
      } else {
        setIsDesktopCompatible(false);
      }
    };

    checkCompatibility();
  }, [feature, compareOperator, desktopVersion]);

  return isDesktopCompatible;
};

// async version
export const isDesktopCompatibility = async (
  args: UseDesktopCompatibleProps,
) => {
  const { feature, compareOperator = '>=', desktopVersion } = args;

  const featureVersion = featureMap[feature] || unreachableFeatureVersion;

  if (isInDesktopMode()) {
    const desktopAppVersion =
      desktopVersion ||
      (await window?.appConfig?.getVersion?.()) ||
      unreachableDesktopVersion;

    return (
      featureVersion &&
      compare(desktopAppVersion, featureVersion, compareOperator)
    );
  }

  return false;
};
